import { call, put, takeLatest } from 'redux-saga/effects';

import { GET_2359_REPORTS_REQUEST } from './constants';
import { SecurityReport2359Service } from './service';
import { get2359ReportsRequest, get2359ReportsSuccess, get2359ReportsError } from './actions';
import { SecurityReport2359 } from './interfaces';

function* get2359ReportsSaga(action: ReturnType<typeof get2359ReportsRequest>) {
  try {
    const reports: SecurityReport2359[] = yield call(SecurityReport2359Service.getReports, action.payload);

    yield put(get2359ReportsSuccess(SecurityReport2359Service.formatReportForTable(reports)));
  } catch (error: any) {
    yield put(get2359ReportsError(error));
  }
}

export function* report2359SagaWatcher() {
  yield takeLatest(GET_2359_REPORTS_REQUEST, get2359ReportsSaga);
}
